import React from "react";
import { useI18n } from "@/lib/i18n";
import { onImgError } from "@/components/gallery/imgError";

/** Step 02 — per-photo revision notes plus one note for the whole order. */
export const NotesStep = ({ selectedPhotos, edits, extras, generalNote, onGeneralNote, onZoom, onDrop, onNote }) => {
  const { t } = useI18n();

  return (
    <>
      <p className="eyebrow mb-4">{t("step_notes")}</p>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-medium">{t("notes_title")}</h1>
      <p className="mt-4 text-sm sm:text-base text-[#A8A8A8] max-w-xl leading-relaxed">{t("notes_body")}</p>

      <div className="mt-10 space-y-px bg-[#2A2A2A] border border-[#2A2A2A]" data-testid="review-list">
        {selectedPhotos.map((photo) => (
          <div key={photo.file_id} className="bg-[#0B0B0B] p-5 flex flex-col sm:flex-row gap-5">
            <button onClick={() => onZoom(photo)} data-testid={`review-zoom-${photo.file_id}`} className="shrink-0">
              <img src={photo.thumb} alt={photo.name} onError={(e) => onImgError(e, photo)}
                className="w-full sm:w-28 h-40 sm:h-28 object-cover border border-[#2A2A2A]" />
            </button>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-3">
                <span className="font-mono-accent text-xs">
                  {photo.name}
                  {extras.includes(photo.file_id) && <span className="ml-2 text-[#D4AF37]">({t("extra")})</span>}
                </span>
                <button data-testid={`review-remove-${photo.file_id}`} onClick={() => onDrop(photo.file_id)}
                  className="text-[10px] tracking-[0.16em] uppercase text-[#707070] hover:text-[#8B0000] min-h-[44px] px-1">
                  {t("remove")}
                </button>
              </div>
              <textarea data-testid={`note-input-${photo.file_id}`} rows={2} value={edits[photo.file_id] || ""}
                onChange={(e) => onNote(photo.file_id, e.target.value)}
                placeholder={t("note_placeholder")}
                className="mt-3 w-full bg-[#050505] border border-[#2A2A2A] p-3 text-base sm:text-sm focus:border-[#D4AF37] focus:outline-none" />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 max-w-xl">
        <label className="eyebrow block mb-3" htmlFor="general-note">{t("general_note")}</label>
        <textarea id="general-note" data-testid="general-note-input" value={generalNote}
          onChange={(e) => onGeneralNote(e.target.value)} rows={4}
          placeholder={t("general_note_placeholder")}
          className="w-full bg-[#0B0B0B] border border-[#2A2A2A] p-4 text-base sm:text-sm focus:border-[#D4AF37] focus:outline-none" />
      </div>
    </>
  );
};
